import { render, staticRenderFns } from "./Bluetooth.vue?vue&type=template&id=ff25bcd8&scoped=true&"
import script from "./Bluetooth.vue?vue&type=script&lang=js&"
export * from "./Bluetooth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff25bcd8",
  null
  
)

export default component.exports